module.exports = __webpack_public_path__ + "05_bob_grey.3084a5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_bob_grey.png
// module id = g02R
// module chunks = 0